import React, { useState } from 'react';
import {
  Box, AlertTitle, Alert, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Grid, TextField, IconButton, Container
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useCarrito } from '../context/CarritoContext';
import Navbar from '../Navbar/Navbar';
import { useNavigate } from 'react-router-dom';

const CarritoPedido = () => {
  const {
    carrito,
    totalCantidad,
    totalPrecio,
    limpiarCarrito,
    modificarCantidad,
    eliminarDelCarrito,
    IdUsuario
  } = useCarrito();

  const Nombre = localStorage.getItem('Nombre');
  const Seguimiento = localStorage.getItem('Seguimiento');
  const Asesor = localStorage.getItem('Asesor');
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState('');
  const [comentario, setComentario] = useState('');
  const [productoNegado, setProductoNegado] = useState('');


  const productos = carrito.map(item => ({
    MSPN: item.MSPN,
    cantidad: item.cantidad
  }));

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      IdUsuario,
      total: totalCantidad,
      productos,
      NombreCambio: Nombre,
      totalPrecio: totalPrecio,
      Comentario: comentario,
      ProducoNoEncontrado: productoNegado,
    };

    try {
      const response = await fetch('https://bibliotecadlago.com/php/pedido.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (!response.ok) {
        setErrorMessage(data.message || 'Error al guardar el pedido');
        return;
      }

      limpiarCarrito();
      navigate('/pedidos.html');

    } catch (error) {
      console.log(error);
      setErrorMessage('Error de conexión con el servidor');
    }
  };

  return (
    <>
      <Navbar />
      <Container maxWidth="lg">
        <Box p={3} display="flex" flexDirection="column" alignItems="stretch">
          {errorMessage && (
            <Alert severity="error" onClose={() => setErrorMessage('')}>
              <AlertTitle>Error</AlertTitle>
              {errorMessage}
            </Alert>
          )}

          <Typography
            variant="h4"
            gutterBottom
            sx={{
              color: '#cf1316',
              fontWeight: 'bold',
              textAlign: 'center'
            }}
          >
            Carrito de Pedido
          </Typography>

          <Grid container spacing={4}>
            <Grid item xs={12} md={6} sx={{ textAlign: 'left', marginRight: 8 }}>
              <Typography><b>Cliente:</b> {Nombre}</Typography>
              <Typography><b>Asesor:</b> {Asesor}</Typography>
              <Typography><b>Seguimiento:</b> {Seguimiento}</Typography>
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ width: '100%', overflowX: 'auto' }}>
                <TableContainer component={Paper} sx={{ mb: 3, minWidth: 50 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">MSPN</TableCell>
                        <TableCell align="center">Descripción</TableCell>
                        <TableCell align="center">Cantidad</TableCell>
                        <TableCell align="center">Precio</TableCell>
                        <TableCell align="center">Eliminar</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {carrito.map((item) => (
                        <TableRow key={item.id}>
                          <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                            {item.MSPN}
                          </TableCell>
                          <TableCell align="center">{item.descripcion}</TableCell>
                          <TableCell align="center">
                            <TextField
                              type="number"
                              value={item.cantidad}
                              onChange={(e) => {
                                const valor = parseInt(e.target.value, 10);
                                if (!isNaN(valor) && valor > 0) {
                                  if (valor <= item.existencias) {
                                    modificarCantidad(item.MSPN, valor);
                                  }


                                }
                              }}
                              inputProps={{ min: 1 }}
                              size="small"
                              sx={{ width: 70 }}
                            />
                          </TableCell>
                          <TableCell align="center">{item.precio}</TableCell>
                          <TableCell align="center">
                            <IconButton
                              onClick={() => eliminarDelCarrito(item.MSPN)}
                              sx={{ color: 'red' }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                      <TableRow>
                        <TableCell colSpan={2} align="center">
                          <strong>Total</strong>
                        </TableCell>
                        <TableCell align="center">
                          <strong>{totalCantidad}</strong>
                        </TableCell>
                        <TableCell align="center">
                          <strong>{totalPrecio}</strong>
                        </TableCell>
                        <TableCell />
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>

          <Box mt={4} width="100%">
            <TextField
              label="Comentario"
              placeholder="Escribe algún comentario adicional sobre el pedido..."
              multiline
              rows={3}
              variant="outlined"
              fullWidth
              value={comentario}
              onChange={(e) => setComentario(e.target.value)}
            />
          </Box>

          <Box
            mt={4}
            display="flex"
            justifyContent="center"
            flexWrap="wrap"
            gap={2}
            width="100%"
          >
            <Button
              variant="contained"
              color="error"
              onClick={limpiarCarrito}
              fullWidth
              sx={{ maxWidth: 250 }}
            >
              Cancelar Pedido
            </Button>

            <Button
              variant="contained"
              onClick={handleSubmit}
              fullWidth
              sx={{
                backgroundColor: 'green',
                '&:hover': { backgroundColor: '#0b7d0b' },
                maxWidth: 250
              }}
            >
              Confirmar Pedido
            </Button>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default CarritoPedido;
